
export default [
    {
        date: '12/11',
        time: '15:00',
        description: 'Estratégia de controle para a operação ótima do reservatório da usina hidrelétrica de Jirau utilizando otimização não linear',
        speaker: 'Brandão Filho, R.C., Ribeiro, F., Galvão Filho, A.R. Carvalho, R.V., Coelho, C.J',
        place: 'Auditório I',
    },
    {
        date: '12/11',
        time: '15:30',
        description: 'Análise do FID na ressonância magnética por imageamento',
        speaker: 'Araújo, G., Costa, A., Costa, R.',
        place: 'Auditório I',
    },
    {
        date: '12/11',
        time: '16:00',
        description: 'Predição da queda da usina de Jirau utilizando redes neurais artificiais recorrentes LSTM',
        speaker: 'Silva, D.F.C., Galvão Filho, A.R., Carvalho, R.V., Coelho, C.J.',
        place: 'Auditório I',
    },
    {
        date: '12/11',
        time: '16:30',
        description: 'Análise de imagens para a quantificação de colônias de bactérias',
        speaker: 'Silva, E. R., Santos, J. M., Galvão Filho, A. R., Gomes, R.P.,Carneiro, C.R., Coelho, C.J.',
        place: 'Auditório I',
    },
    {
        date: '12/11',
        time: '17:00',
        description: 'Apresentação de Posters',
        speaker: '-',
        place: 'Hall dos Auditório II e III',
    },
    {
        date: '14/11',
        time: '15:00',
        description: 'Modelagem de sistema de partida e parada de uma turbina hidrelétrica usando redes Petri',
        speaker: 'Silva, C.O., Carvalho, R.V., Galvão Filho, A.R., Coelho, C.J.',
        place: 'Auditório I',
    },
    {
        date: '14/11',
        time: '15:30',
        description: 'Simulador de Testes Adaptativos Baseado na Proficiência do Aluno',
        speaker: 'Brandão, H. M. de L., Brandão, H. M. de L.',
        place: 'Auditório I',
    },
    {
        date: '14/11',
        time: '16:00',
        description: 'Identificação de erros na lista de conectividade de circuito elétrico empregando analisador léxico e sintático',
        speaker: 'Sousa, G. T. A., Machado, B. S., Brodbeck, L. C., Galvão Filho, A.R., Carvalho, R.V. , Coelho, C.J.',
        place: 'Auditório I',
    },
    {
        date: '14/11',
        time: '16:30',
        description: 'Avaliação de implementações de algoritmos genéticos na estimação DOA',
        speaker: 'Neto, A.A.S.; Silva, H.V.L.; Xavier, D.S.; Lemos, R.P.; Kunzler, J.A.; Coelho, A.A.S; Ferreira, L.R.',
        place: 'Auditório I',
    },
    {
        date: '14/11',
        time: '17:00',
        description: 'Detecção de discos de antibióticos em imagens de teste de disco-difusão (Kirby-Bauer) utilizando redes neurais convolucionais',
        speaker: 'Nascimento,V. D., Borges, J.P.N., Galvão Filho, A.R., Gomes, R.P.,Carneiro, L.C., Coelho, C.J.',
        place: 'Auditório I',
    },
    {
        date: '14/11',
        time: '17:30',
        description: 'Análise nodal de circuito elétrico empregando computação paralela GPU CUDA',
        speaker: 'Machado, B.S. , Chaves, L. B. ,Galvão Filho, A.R. , Carvalho, R.V. , Coelho, C.J.',
        place: 'Auditório I',
    },
]